import type { TourConfig } from '../../types/tour.types'

// List Builder — EMPTY state (no filters applied yet). Shown while the
// Saved/ICP/History panels + AI Search card are on screen. The results-state
// tour (listbuilder-results.tour.ts) takes over once results are showing.
const listBuilderTour: TourConfig = {
  id: 'listbuilder',
  title: 'Build a targeted list',
  module: 'Prospecting',
  routeName: 'ListBuilder',
  order: 2,
  autoStart: true,
  condition: () => !!document.querySelector('.list-builder-view__panels'),
  steps: [
    {
      id: 'intro',
      title: 'Stop guessing who to contact',
      body: 'List Builder turns thousands of companies into a **short, precise list** that matches your ideal customer. The tighter the list, the higher your reply rate — and the fewer credits you waste.',
    },
    {
      id: 'filters',
      target: '.filter-sidebar-wrap',
      placement: 'end',
      title: 'Narrow by what actually matters',
      body: 'Filter by industry, size, location, technologies and more. Each filter you add is a reason a prospect is a **good fit** — so your outreach feels relevant, not spammy.',
    },
    {
      id: 'panels',
      target: '.list-builder-view__panels',
      placement: 'top',
      title: 'Pick up where you left off',
      body: 'Three shortcuts to a list without starting from scratch:\n- **Saved Searches** — rerun a search you saved earlier\n- **Lead Scoring Searches** — run a list built from your ideal customer profile\n- **History** — replay any recent search',
    },
    {
      id: 'ai-search',
      target: '.ai-search',
      placement: 'bottom',
      optional: true,
      title: 'Just describe who you want',
      body: 'Type your ideal customer in **plain English** — like *"SaaS companies in New York with 50–200 employees"* — and the AI translates it into the right filters for you. No need to learn every filter first.',
    },
  ],
}

export default listBuilderTour
